/**
 * Generates a unique event ID string.
 *
 * The ID is composed of the current timestamp in milliseconds,
 * concatenated with a dot and a random string of 10 base36 characters.
 *
 * @remarks
 * This function is useful for generating unique identifiers for events,
 * logs, or other entities where a high probability of uniqueness is required.
 *
 * @returns {`${number}.${string}`} A string in the format `${timestamp}.${randomString}`,
 * where `timestamp` is the current time in milliseconds and `randomString` is a
 * 10-character alphanumeric string in base36.
 *
 * @example
 * ```ts
 * const id = generateEventID();
 * // Example output: "1667412119253.at34uersu7"
 * ```
 */
function generateEventID() {
    const timestamp = Date.now();
    const randomString = Math.random().toString(36).substring(2, 12);
    return `${timestamp}.${randomString}`;
}

export { generateEventID };
//# sourceMappingURL=generateEventID.js.map
